(function ($) {
    var TAB_KEY_CODE = 9;

	var $html = $('html');

	$(window).on('keydown', function (e) {
		if (e.which === TAB_KEY_CODE) {
			$html.addClass('user-is-tabbing');
		}
	});

	$(document).on('mousedown', function() {
		$html.removeClass('user-is-tabbing');
	});
})(jQuery);
